import { AdHocData } from './addHocData';

export const AdHoc = {
  dataStore: AdHocData,
  name: 'AD_HOC',
  tacticLabel: 'Ad Hoc',
  addTacticLabel: 'Add Ad Hoc',
  category: 'Setup',

  tradePlanFormModule: null,
  tacticPanel: null,
  addTacticPanel: null,
  wrapper: null,
  chartSoftOrderComponent: null,
  documentation: null,
  alertDetailsComponent: null,
  alertTableSetupComponent: null,

  setupDetailParser: () => null,
  setupNotificationParser: () => null,
  determineTimeUnit: () => null,
  determineCandleDuration: () => null,
  validateFunction: () => null,
};
